import { render, staticRenderFns } from "./WarrantyTiers.vue?vue&type=template&id=8defb040&scoped=true"
import script from "./WarrantyTiers.vue?vue&type=script&lang=js"
export * from "./WarrantyTiers.vue?vue&type=script&lang=js"
import style0 from "./WarrantyTiers.vue?vue&type=style&index=0&id=8defb040&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8defb040",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/WarrantyTiers.vue
// module id = 159
// module chunks = 0